"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentCodeForStatusId = exports.paymentFailed = exports.completed = exports.processFailed = void 0;
var paymentCodes = __importStar(require("../../constants/paymentCodes"));
/**
 * These error codes signify that something went wrong with the emission process, and it must be
 * terminated.
 * They should break the check logic, and automatically throw a fatal retry error
 *
 * @param code - The last code detected for the emission
 */
function processFailed(code) {
    return [
        paymentCodes.PERSON_CREATION_FAILURE,
        paymentCodes.POLICY_CREATION_FAILURE,
        paymentCodes.PAYMENT_DENIED,
        paymentCodes.PAYMENT_FAILED,
        paymentCodes.POLICY_ACTIVATION_FAILURE,
    ].includes(code);
}
exports.processFailed = processFailed;
/**
 * These status codes represent a "success" payment attempt from the front's point of
 * view. Note that it includes some failed codes because those are considered as "internal"
 * errors that should be reported to ASSA, but they should not notify the customer.
 *
 * @param code - The last code detected for the emission
 */
function completed(code) {
    return [
        paymentCodes.POLICY_ACTIVATION_SUCCESS,
        paymentCodes.PAYMENT_APPLICATION_SUCCESS,
        paymentCodes.PAYMENT_APPLICATION_FAILURE,
    ].includes(code);
}
exports.completed = completed;
/**
 * Returns true if the payment failed due to an error that the user can fix.
 *
 * @param code - The last code detected for the emission
 */
function paymentFailed(code) {
    return [paymentCodes.PAYMENT_FAILED].includes(code);
}
exports.paymentFailed = paymentFailed;
function paymentCodeForStatusId(id) {
    var usedOffset = id - 1;
    if (usedOffset >= 0 && usedOffset <= paymentCodes.statusOrder.length - 1) {
        return paymentCodes.statusOrder[usedOffset];
    }
    return '';
}
exports.paymentCodeForStatusId = paymentCodeForStatusId;
//# sourceMappingURL=paymentCodeMethods.js.map